/**
 * The Demand Note's custom charge (the free title + amount the reviewer adds
 * on the Demand Note form, saved as custom_charge_title / custom_charge_amount)
 * as a row for the Payment Details charge lists on the L1/L2/L3 Final Review
 * screens.
 *
 * The amount is already part of the saved Total Amount; the lists only lacked
 * its own row, so the rows did not add up to the total. Like the Demand Note
 * PDF (demand-note-plot-Bahadura.hbs), the row is shown only when the amount
 * is above 0, and is called "Other / Additional Charges" when no title was
 * typed.
 */

/**
 * The payment screens get the saved row as stored (custom_charge_title /
 * custom_charge_amount); the Demand Note form's data uses customChargeTitle /
 * customChargeAmount. Either is read.
 */
type TSavedDemandNote = {
  custom_charge_title?: string | null;
  custom_charge_amount?: number | string | null;
  customChargeTitle?: string | null;
  customChargeAmount?: number | string | null;
};

export const CUSTOM_CHARGE_FALLBACK_LABEL = "Other / Additional Charges";

/** [] when there is no custom charge, else one { label, value } row. */
export function customChargeItems(
  demandNote: TSavedDemandNote | null | undefined
): { label: string; value: number }[] {
  const amount = Number(demandNote?.custom_charge_amount ?? demandNote?.customChargeAmount) || 0;
  if (amount <= 0) return [];
  const title = String(demandNote?.custom_charge_title ?? demandNote?.customChargeTitle ?? "").trim();
  return [{ label: title || CUSTOM_CHARGE_FALLBACK_LABEL, value: amount }];
}
